/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2019 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../../core/IceEntity';
import { IceTypes } from '../../icetypes';
import { managementguideline } from './managementguideline';

export class managementguidelineindex extends managementguideline {
  gettablename(): string {
    return "MANAGEMENT_GUIDELINE_INDEX";
  }
}
